import api from "../../API/apiConfig";

// 1. Lấy danh sách Events
export const getEvents = (filter) => {
  return api.get(`/events`, {params: filter});
};

// 2. Thêm mới Event
export const addEvent = (eventData) => {
  return api.post("/events/add", eventData);
};

// 3. Cập nhật Event theo ID
export const updateEvent = (id, eventData) => {
  return api.put(`/events/update/${id}`, eventData);
};

// 3.1. Cập nhật Event time theo ID
export const updateEventTime = (id, eventData) => {
  return api.put(`/events/update-time/${id}`, eventData);
};

// 4. Xóa Event theo ID
export const deleteEvent = (id) => {
  return api.delete(`/events/delete/${id}`);
};

// 5. Xem chi tiết một Event theo ID
export const getEventDetail = (id) => {
  return api.get(`/events/detail/${id}`);
};

// 6. Xem danh sách Event theo Type và recordId
export const getEventByType = (type, recordId) => {
  return api.get(`/events/${type}/${recordId}`);
};
